import { render } from "./Recover.vue?vue&type=template&id=9ddb6cf2&scoped=true"
import script from "./Recover.vue?vue&type=script&lang=js"
export * from "./Recover.vue?vue&type=script&lang=js"

import "./Recover.vue?vue&type=style&index=0&id=9ddb6cf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ddb6cf2"]])

export default __exports__